import ApplicationModel, { attr } from '../ApplicationModel';
import { type AnnotationAttributes } from './generated/AnnotationAttributes';
import { model } from '../modelBuilder';

interface Annotation extends AnnotationAttributes {}

@model
class Annotation extends ApplicationModel {
  // Start auto-generated
  static typename: 'Annotation' = 'Annotation';
  get typename(): 'Annotation' {
    return 'Annotation';
  }

  static internalTypename: 'Annotation' = 'Annotation';
  get internalTypename(): 'Annotation' {
    return 'Annotation';
  }

  static inputType = 'AnnotationAttributes!';

  static filterType = 'AnnotationFilters!';
  static filters = {
    id: '[ID!]',
    type: 'AnnotationTypeEnum',
    resolved: 'Boolean',
    annotatableId: '[ID!]',
    annotatableType: 'AnnotatableTypeEnum',
  };

  static fields = {
    accountId: attr({ readable: true }),
    commentsCount: attr({ readable: true }),
    configuration: attr({ writable: true, readable: true, json: true }),
    createdAt: attr({ readable: true }),
    displaySpeakerName: attr({ readable: true }),
    highlightText: attr({ readable: true }),
    id: attr({ writable: true, readable: true }),
    name: attr({ readable: true }),
    resolved: attr({ writable: true, readable: true }),
    resolvedAt: attr({ readable: true }),
    speakerPath: attr({ readable: true }),
    tagList: attr({ readable: true }),
    thumbnailUrl: attr({ readable: true }),
    type: attr({ writable: true, readable: true }),
    updatedAt: attr({ readable: true }),
    userId: attr({ readable: true }),
    account: attr.belongsTo({ readable: true, typename: 'Account' }),
    annotatable: attr.belongsTo({
      writeShape: ['id', 'typename'],
      readable: true,
      typename: ['Note', 'Unimplemented'],
    }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    user: attr.belongsTo({ readable: true, typename: 'User' }),
    comments: attr.hasMany({ readable: true }),
    tags: attr.hasMany({ writable: true, readable: true }),
    tasks: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  // All
  get text() {
    return this.configuration?.text;
  }

  // Helpers to match in editor annotations
  get annotationKey() {
    return this.id;
  }

  get key() {
    return this.id;
  }

  // Quote annotation type
  get quoteTitle() {
    return this.configuration?.quote_title;
  }

  // Learning annotation type
  get learningText() {
    return this.configuration?.learning_text;
  }

  get learningTitle() {
    return this.configuration?.learning_title;
  }

  // Clip annotation type
  get clipText() {
    return this.configuration?.clip_text;
  }

  get clipTitle() {
    return this.configuration?.clip_title;
  }

  // Summary annotation type
  get summary() {
    return this.configuration?.summary;
  }
}

export default Annotation;
